/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

//TODO there is another version of this list in en.json!

const humanLanguageMap = {
  ar: 'Arabic',
  cs: 'Czech',
  de: 'German',
  en: 'English (US)',
  es: 'Spanish',
  fr: 'French',
  it: 'Italian',
  ja: 'Japanese',
  ko: 'Korean',
  nl: 'Dutch',
  'pt-br': 'Brazilian Portuguese',
  'zh-tw': 'Chinese (Traditional)',
  'zh-cn': 'Chinese (Simplified)',
  xx: 'Another language'
};

export const capitalizeFirstLetter = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const capitalizeEachWord = (str: string) => {
  return str
    ? str
        .split(' ')
        .map(w => capitalizeFirstLetter(w))
        .join(' ')
    : str;
};

const formatToHuman = (label: string) =>
  (label + '')
    .toLowerCase()
    .replace('_', ' ')
    .split(' ')
    .map(v => capitalizeFirstLetter(v))
    .join(' ');

export const envLanguageToHumanReadable = ({
  value,
  label,
  beta
}: {
  value: string;
  label: string;
  beta: boolean;
}): string =>
  humanLanguageMap[value]
    ? beta
      ? humanLanguageMap[value] + ' - Beta'
      : humanLanguageMap[value]
    : formatToHuman(label);

export const trimAll = (str: string) => str.trim().replace(/\s+/g, ' ');

/**
 * Default character string to output to redact a sensitive or
 * password field.
 */
export const REDACTED_FIELD = '••••••••••';
